import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, Suggest2, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Checkbox, Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";


import { AxiosInstance } from 'axios';

import * as utils from "../utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from '../svg/wait2.gif'

import { FBSCCYInfo } from '../Types'
import { SystemHeader } from '../CommonUI';
import { Pagination, PageInfo } from '../CommonUI';

import i18next from 'i18next';


var GsbFlag: any;

var UserID: string;
var PgmCode = "M0007" ;
var isReqAuth2:boolean = false ;

interface FBSCCYMastViewProps {
    gsb: AxiosInstance,
    ccy: FBSCCYInfo,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
}


export function FBSCCYMastView({ gsb, ccy = {} as FBSCCYInfo, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { } }: FBSCCYMastViewProps) {


    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
    
/*
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
*/

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            //setisReqAuth(true)
                            //isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, ccy])

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    if (! ("d_Curcy" in ccy)) return null


    return (
        <div>
            {/* define add,change,delete button */}
            <div className="Row">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                
                <Button className="Col-2-1" disabled={isReadOnly} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={isReadOnly} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
            </div>

            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Currency">
                    <InputGroup readOnly value={ccy.d_Curcy} />
                </FormGroup>
                <FormGroup className="Col-2-3" label="Name">
                    <InputGroup readOnly value={ccy.d_CurcyName} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Default Base">
                    <InputGroup readOnly type='number' value={utils.numToString(ccy.d_CBase)} />
                </FormGroup>
                <FormGroup className="Col-2-1" label="Exch. Rate">
                    <InputGroup readOnly type='number' value={utils.numToString(ccy.d_Exchange)} />
                </FormGroup>
                <FormGroup className="Col-3-1" label="Last Update">
                    <InputGroup readOnly value= {utils.dispDate(ccy.d_EDate, GsbFlag.dateFormat)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Default Bank Account# - Client">
                    <InputGroup readOnly value={ccy.d_CBank} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Default Bank Account# - House">
                    <InputGroup readOnly value={ccy.d_HBank} />
                </FormGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-2" disabled inline selectedValue={ccy.d_HKFE ? "Y" : "N"} label="HKFE" onChange={()=>{}}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                </RadioGroup>
            </div>

            <div className="Spacing-V-16" />
            <H5>Interest Calculation</H5>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Decimal Places">
                    <InputGroup readOnly type='number' value={utils.numToString(ccy.d_Dec)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Days of year">
                    <InputGroup readOnly type='number' value={utils.numToString(ccy.d_Days)} />
                </FormGroup>
                <FormGroup className="Col-2-1" label="Prime">
                    <InputGroup readOnly type='number' value={utils.numToString(ccy.d_Prime)} />
                </FormGroup>
                <FormGroup className="Col-3-1" label="Last Update">
                    <InputGroup readOnly value= {utils.dispDate(ccy.d_PDate, GsbFlag.dateFormat)} />
                </FormGroup>
            </div>
        </div>
    )
}

interface FBSCCYMastEditProps {
    gsb: AxiosInstance,
    ccy?: FBSCCYInfo,
    isNew?: boolean,
    onSave?: (stk: FBSCCYInfo) => void,
    onCancel?: () => void,
}

export function FBSCCYMastEdit({ gsb, ccy = {} as FBSCCYInfo, isNew = false, onSave = () => { }, onCancel = () => { } }: FBSCCYMastEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<FBSCCYInfo>()

    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)

    const [HKFEValue, setHKFEValue] = useState(ccy.d_HKFE ? "Y" : "N")

    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        // Call reset to get the values of record ClientTranInfo 
        if ("d_Curcy" in ccy) {
            reset(ccy)
        }
    }, [ccy, reset])


    useEffect(() => {
        // Some components (e.g. Suggest) don't have ref to use with react-hook-form, so register the fields manually and call setValue when item is selected
        // register({ name: "d_FieldName" })
    }, [register])


    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    if (! isNew && ! ("d_Curcy" in ccy)) return null

   
    const onSubmit = (data: FBSCCYInfo) => {
        // put value to json/field before write database dbf
        data.d_HKFE = (HKFEValue === "Y");

        (async () => {
            try {
                const res = await gsb.post('/fbs/Master', {sb_data: data, cPgmId: "CCYMast", cAction: "CCYMastValidate", isNew: isNew})

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }

                    return
                }
                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }

             </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Currency" labelFor="d_Curcy" labelInfo="*">
                    <InputGroup disabled={!isNew} id="d_Curcy" name="d_Curcy" defaultValue={ccy.d_Curcy} placeholder="Currency ..." onChange={utils.handleStringChange(s => setValue("d_Curcy", s.toUpperCase()))} inputRef={register({ required: true , maxLength: 3}) } />
                    {errors.d_Curcy && errors.d_Curcy.type === "required" && <span id="Err_msg">Currency cannot be Blank</span>}
                    {errors.d_Curcy && errors.d_Curcy.type === "maxLength" && <span id="Err_msg">Max length is 3</span>}
                    {errors.d_Curcy && errors.d_Curcy.types && <span id="Err_msg">{errors.d_Curcy.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-3" label="Name" labelFor="d_CurcyName" labelInfo="*">
                    <InputGroup id="d_CurcyName" name="d_CurcyName" defaultValue={ccy.d_CurcyName} placeholder="Currency Name ..." onChange={utils.handleStringChange(s => setValue("d_CurcyName", s.toUpperCase()))} inputRef={register({ required: true , maxLength: 25}) } />
                    {errors.d_CurcyName && errors.d_CurcyName.type === "required" && <span id="Err_msg">Currency Name cannot be Blank</span>}
                    {errors.d_CurcyName && errors.d_CurcyName.type === "maxLength" && <span id="Err_msg">Max length is 25</span>}
                    {errors.d_CurcyName && errors.d_CurcyName.types && <span id="Err_msg">{errors.d_CurcyName.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Default Base" labelFor="d_CBase">
                    <InputGroup id="d_CBase" name="d_CBase" defaultValue={"0"} type="number" placeholder="" inputRef={register({ min: 0}) } />
                    {errors.d_CBase && errors.d_CBase.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_CBase && errors.d_CBase.types && <span id="Err_msg">{errors.d_CBase.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-1" label="Exch. Rate" labelFor="d_Exchange">
                    <InputGroup id="d_Exchange" name="d_Exchange" defaultValue={"0"} type="number" placeholder="" inputRef={register({ min: 0}) } />
                    {errors.d_Exchange && errors.d_Exchange.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_Exchange && errors.d_Exchange.types && <span id="Err_msg">{errors.d_Exchange.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-1" label="Last Update" labelFor="d_EDate">
                    <InputGroup id="d_EDate" name="d_EDate" defaultValue="" type="date" inputRef={register} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Default Bank Account# - Client" labelFor="d_CBank">
                    <InputGroup id="d_CBank" name="d_CBank" defaultValue={ccy.d_CBank} placeholder="Bank Account# ..." onChange={utils.handleStringChange(s => setValue("d_CBank", s.toUpperCase()))} inputRef={register({ maxLength: 12}) } />
                    {errors.d_CBank && errors.d_CBank.type === "maxLength" && <span id="Err_msg">Max length is 12</span>}
                    {errors.d_CBank && errors.d_CBank.types && <span id="Err_msg">{errors.d_CBank.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Default Bank Account# - House" labelFor="d_HBank">
                    <InputGroup id="d_HBank" name="d_HBank" defaultValue={ccy.d_HBank} placeholder="Bank Account# ..." onChange={utils.handleStringChange(s => setValue("d_HBank", s.toUpperCase()))} inputRef={register({ maxLength: 12}) } />
                    {errors.d_HBank && errors.d_HBank.type === "maxLength" && <span id="Err_msg">Max length is 12</span>}
                    {errors.d_HBank && errors.d_HBank.types && <span id="Err_msg">{errors.d_HBank.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-2" inline selectedValue={HKFEValue} label="HKFE" onChange={utils.handleStringChange(s => setHKFEValue(s))}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                </RadioGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Decimal Places" labelFor="d_Dec">
                    <InputGroup id="d_Dec" name="d_Dec" defaultValue={"0"} type="number" placeholder="" inputRef={register({ min: 0}) } />
                    {errors.d_Dec && errors.d_Dec.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_Dec && errors.d_Dec.types && <span id="Err_msg">{errors.d_Dec.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Days of year" labelFor="d_Days">
                    <InputGroup id="d_Days" name="d_Days" defaultValue={"0"} type="number" placeholder="" inputRef={register({ min: 0}) } />
                    {errors.d_Days && errors.d_Days.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_Days && errors.d_Days.types && <span id="Err_msg">{errors.d_Days.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-1" label="Prime" labelFor="d_Prime">
                    <InputGroup id="d_Prime" name="d_Prime" defaultValue={"0"} type="number" placeholder="" inputRef={register} />
                    {errors.d_Prime && errors.d_Prime.types && <span id="Err_msg">{errors.d_Prime.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-1" label="Last Update" labelFor="d_PDate">
                    <InputGroup id="d_PDate" name="d_PDate" defaultValue="" type="date" inputRef={register} />
                </FormGroup>
            </div>
        </form>
    )
}

interface FBSCCYMastMainProps {
    gsb: AxiosInstance
}

// const toaster = Toaster.create({
//     position: Position.TOP,
// })

function FBSCCYMastMain({ gsb }: FBSCCYMastMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { market: defaultSearchValue = "" }: { market: string } = useParams()

    const [isReadOnly, setisReadOnly] = useState(false)

    const [data, setData] = useState([] as FBSCCYInfo[])

    const [searchKey, setSearchKey] = useState("curcy")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)

    const [showFilters, setShowFilters] = useState(false)
    const [searchCCYName, setSearchCCYName] = useState("")
    
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentCCY, setCurrentCCY] = useState({} as FBSCCYInfo)

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                UserID = res.data.Flag.UserID
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) 
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        setisReadOnly(false)
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("CCYMastMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])



    const PrevRecProcess = async (ccy: FBSCCYInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: ccy, cPgmId: "CCYMast", cAction: "PrevRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Curcy === res.data.data.d_Curcy) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentCCY(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (ccy: FBSCCYInfo) => {
        try {
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/fbs/Master', {sb_data: ccy, cPgmId: "CCYMast", cAction: "DelRec"})
            utils.showSuccess("Currency " + ccy.d_Curcy + " record deleted")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Curcy === res.data.data.d_Curcy) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentCCY(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (ccy: FBSCCYInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: ccy, cPgmId: "CCYMast", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Curcy === res.data.data.d_Curcy) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentCCY(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (ccy: FBSCCYInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: ccy, cPgmId: "CCYMast", cAction: "AddRec"})
            utils.showSuccess("Currency " + res.data.data.d_Curcy + " record added")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Curcy === res.data.data.d_Curcy) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentCCY(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (ccy: FBSCCYInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: ccy, cPgmId: "CCYMast", cAction: "UpdateRec"})
            utils.showSuccess("Currency " + ccy.d_Curcy + " record saved")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Curcy === res.data.data.d_Curcy) {
                    data[i] = { ...data[i], ...res.data.data }
                    //console.log("editOnSave data", i, data)
                    setData(data)
                    break
                }
            }
            //console.log("editOnSave res.data.data", res.data.data)
            setCurrentCCY(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
        
        try {
            //console.log("CCYMastMain onsubmit called", data)
            if ( m_limit > 1 ) {
                const res = await gsb.post('/fbs/Master',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                            curcyName: searchCCYName,
                        }, 
                    },
                    cPgmId: "CCYMast",
                    cAction: "ListRec",
                });

                //console.log("onSubmit res.data.data", res.data.data)
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentCCY(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
    
            } else {
                const res = await gsb.post('/fbs/Master',
                {   sb_data: {
                        d_Curcy: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "CCYMast",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    //console.log("GetRec res.data.data", res.data.data)
                    setCurrentCCY(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }

            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 
    
            (async () => {
                //console.log("CCYMastMain useEffect length > 0  called", data)
                const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: "curcy",
                            start: defaultSearchValue,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "CCYMast",
                        cAction: "ListRec",
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentCCY(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue])

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                                curcyName: searchCCYName,
                            }, 
                        },
                        cPgmId: "CCYMast",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setCurrentCCY(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])
    

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    // currentMode = show
    let detail = <FBSCCYMastView gsb={gsb} ccy={currentCCY} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentCCY)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentCCY)} onNextRec={() => NextRecProcess(currentCCY)}></FBSCCYMastView>
    switch (currentMode) {
        case "new":
            //console.log("currentMode = new")
            detail = <FBSCCYMastEdit gsb={gsb} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></FBSCCYMastEdit>
            break
        case "edit":
            //console.log("currentMode = edit")
            detail = <FBSCCYMastEdit gsb={gsb} ccy={currentCCY} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></FBSCCYMastEdit>
            break
        }

    let pagination = <Pagination nPage={nPage} nTotalPage={nTotalPage} aPageNumber={aPageNumber} setnPage={(n)=>setnPage(n)}></Pagination>
    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" disabled={isReadOnly} icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-100">Currency</th>
                <th className="TCol-300">Name</th>
            </thead>
            <tbody id="ma_tr">
                {data.map((ccy, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td onClick={() => { setCurrentCCY(ccy) ; MoblieDev && setSelectedTabId("detail") }}>{ccy.d_Curcy}</td>
                        <td onClick={() => { setCurrentCCY(ccy) ; MoblieDev && setSelectedTabId("detail") }}>{ccy.d_CurcyName}</td>
                        {/* <td onClick={() => { setCurrentCCY(ccy) }}>{ccy.d_Action}</td> */}
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Currency Information</H3>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        {/* define search key */}
                        <FormGroup className="Col-1-5" label="Search for" labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="curcy">Currency</option>
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "curcy"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "curcy"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>
                        </div>
                    <Collapse isOpen={showFilters}>
                        <div className="Row">
                            {/* define search filter */}
                            <FormGroup className="Col-1-2" label="Currency Name" labelFor="searchCCYName">
                                <InputGroup id="searchCCYName" value={searchCCYName} onChange={utils.handleStringChange(s => setSearchCCYName(s.toUpperCase()))} />
                            </FormGroup>
                            {/* <FormGroup className="Col-6-2" label="No. of record(s) to List" labelFor="searchLimit" >
                                <InputGroup className="Input-XS" id="searchLimit" value={searchLimit.toString()} onChange={utils.handleNumberChange(n => setSearchLimit(n))} />
                            </FormGroup> */}
                        </div>
                    </Collapse>
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card>

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default FBSCCYMastMain